export const fetchTrackingSettings = async () => {
     const url = process.env.REACT_APP_TRACKING_API_URL || "";
     const response = await fetch(url);
     return response.json();
};
